<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Colloques " />
            <ColloqueDetails />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import ColloqueDetails from '../Colloque/ColloqueDetails.vue'


export default {
    name: 'ColloquePage',
    components: {
        NavBar,
        PageTitle,
        ColloqueDetails,
        FooterComp,
    }
}
</script>